import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useStateGetter } from "./UseStateGettersHook";
import { ModalPropsDTO } from "../../typings/generic";

const useStateSetter = () => {
  const dispather = useDispatch();
  const setAuthuser = (payload: any) => {
    dispather({ type: "set-authuser", payload: payload });
  };
  const setSelecteduser = (payload: any) => {
    dispather({ type: "set-selectedUser", payload: payload });
  };

  const showModal = (
    title: string,
    message: string,
    icon?: any,
    action?: any
  ) => {
    var modalprops: ModalPropsDTO = {
      title: title,
      message: message,
      icon: icon,
      action: action,
    };
    dispather({ type: "set-modalProps", payload: modalprops });

    setShowModal(true);
  };
  const setLoading = (payload: boolean) => {
    dispather({ type: "set-loading", payload: payload });
  };
  const setConfig = (payload: {}) => {
    dispather({ type: "set-config", payload: payload });
  };

  const setVerifyEmail = (payload: string) => {
    dispather({ type: "set-verifyEmail", payload: payload });
  };
  const setShowModal = (payload: boolean) => {
    dispather({ type: "set-modal", payload: payload });
  };
  const setallmodules=(payload:[])=>{
    dispather({ type: "set-modules", payload: payload });

  }
  const setSelectedorg=(payload:{})=>{
    dispather({ type: "set-selected-org", payload: payload });

  }
  const setSidebarRenderView=(payload:{})=>{
    dispather({ type: "set-sidebarrender", payload: payload });

  }
  const setselectedDept=(payload:{})=>{
    dispather({ type: "set-selectedDept", payload: payload });

  }
  const setselectedEmpl=(payload:{})=>{
    dispather({ type: "set-selectedemployee", payload: payload });

  }
  const setShowwiz=(payload:{})=>{
    dispather({ type: "set-showWizard", payload: payload });

  }
  const setBreadTitle=(payload:{})=>{
    dispather({ type: "set-breadTitle", payload: payload });

  }

  return {setSelectedorg,
    setAuthuser,
    setBreadTitle,
    setVerifyEmail,
    setallmodules,
    setConfig,
    setShowModal,
    setShowwiz,
    setselectedEmpl,
    setselectedDept,
    showModal,
    setSidebarRenderView,
    setSelecteduser,
    setLoading,
  };
};

export { useStateSetter };
